export function isLoggedIn() {
    return JSON.parse(localStorage.getItem("customerInfo")) != null ? true : false;
}